"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useResize;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var React = _interopRequireWildcard(require("react"));
var _useSizes = require("./useSizes");
/**
 * Handle user drag resize logic.
 */
function useResize(items, resizableInfos, percentSizes, containerSize, updateSizes) {
  var limitSizes = items.map(function (item) {
    return [item.min, item.max];
  });
  var mergedContainerSize = containerSize || 0;
  var ptg2px = function ptg2px(ptg) {
    return ptg * mergedContainerSize;
  };
  // ======================== Resize ========================
  function getLimitSize(str, defaultLimit) {
    if (typeof str === 'string') {
      return ptg2px((0, _useSizes.getPtg)(str));
    }
    return str !== null && str !== void 0 ? str : defaultLimit;
  }
  // Real px sizes
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    cacheSizes = _React$useState2[0],
    setCacheSizes = _React$useState2[1];
  /**
   * When start drag, check the direct is `start` or `end`.
   * This will handle when 2 splitter bar are in the same position.
   */
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    movingIndex = _React$useState4[0],
    setMovingIndex = _React$useState4[1];
  var getPxSizes = function getPxSizes() {
    return percentSizes.map(ptg2px);
  };
  var onOffsetStart = function onOffsetStart(index) {
    setCacheSizes(getPxSizes());
    setMovingIndex({
      index: index,
      confirmed: false
    });
  };
  var onOffsetUpdate = function onOffsetUpdate(index, offset) {
    var _a;
    // First time trigger move index update is not sync in the state
    var confirmedIndex = null;
    // We need to know what the real index is.
    if ((!movingIndex || !movingIndex.confirmed) && offset !== 0) {
      // Search for the real index
      if (offset > 0) {
        confirmedIndex = index;
        setMovingIndex({
          index: index,
          confirmed: true
        });
      } else {
        for (var i = index; i >= 0; i -= 1) {
          if (cacheSizes[i] > 0 && resizableInfos[i].resizable) {
            confirmedIndex = i;
            setMovingIndex({
              index: i,
              confirmed: true
            });
            break;
          }
        }
      }
    }
    var mergedIndex = (_a = confirmedIndex !== null && confirmedIndex !== void 0 ? confirmedIndex : movingIndex === null || movingIndex === void 0 ? void 0 : movingIndex.index) !== null && _a !== void 0 ? _a : index;
    var numSizes = (0, _toConsumableArray2["default"])(cacheSizes);
    var nextIndex = mergedIndex + 1;
    // Get boundary
    var startMinSize = getLimitSize(limitSizes[mergedIndex][0], 0);
    var endMinSize = getLimitSize(limitSizes[nextIndex][0], 0);
    var startMaxSize = getLimitSize(limitSizes[mergedIndex][1], mergedContainerSize);
    var endMaxSize = getLimitSize(limitSizes[nextIndex][1], mergedContainerSize);
    var mergedOffset = offset;
    // Align with the boundary
    if (numSizes[mergedIndex] + mergedOffset < startMinSize) {
      mergedOffset = startMinSize - numSizes[mergedIndex];
    }
    if (numSizes[nextIndex] - mergedOffset < endMinSize) {
      mergedOffset = numSizes[nextIndex] - endMinSize;
    }
    if (numSizes[mergedIndex] + mergedOffset > startMaxSize) {
      mergedOffset = startMaxSize - numSizes[mergedIndex];
    }
    if (numSizes[nextIndex] - mergedOffset > endMaxSize) {
      mergedOffset = numSizes[nextIndex] - endMaxSize;
    }
    // Do offset
    numSizes[mergedIndex] += mergedOffset;
    numSizes[nextIndex] -= mergedOffset;
    updateSizes(numSizes);
    return numSizes;
  };
  var onOffsetEnd = function onOffsetEnd() {
    setMovingIndex(null);
  };
  // ======================= Collapse =======================
  var onCollapse = function onCollapse(index, type) {
    var currentSizes = getPxSizes();
    var currentIndex = type === 'start' ? index : index + 1;
    var targetIndex = type === 'start' ? index + 1 : index;
    var currentSize = currentSizes[currentIndex];
    var targetSize = currentSizes[targetIndex];
    if (currentSize !== 0 && targetSize !== 0) {
      // Collapse directly
      currentSizes[currentIndex] = 0;
      currentSizes[targetIndex] += currentSize;
    } else {
      var totalSize = currentSize + targetSize;
      var currentSizeMin = getLimitSize(limitSizes[currentIndex][0], 0);
      var currentSizeMax = getLimitSize(limitSizes[currentIndex][1], mergedContainerSize);
      var targetSizeMin = getLimitSize(limitSizes[targetIndex][0], 0);
      var targetSizeMax = getLimitSize(limitSizes[targetIndex][1], mergedContainerSize);
      var limitStart = Math.max(currentSizeMin, totalSize - targetSizeMax);
      var limitEnd = Math.min(currentSizeMax, totalSize - targetSizeMin);
      var halfOffset = (limitEnd - limitStart) / 2;
      currentSizes[currentIndex] -= halfOffset;
      currentSizes[targetIndex] += halfOffset;
    }
    updateSizes(currentSizes);
    return currentSizes;
  };
  return [onOffsetStart, onOffsetUpdate, onOffsetEnd, onCollapse, movingIndex === null || movingIndex === void 0 ? void 0 : movingIndex.index];
}